import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/site/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-stars-bg"></div>
      
      <div className="container">
        <div className="footer-top">
          <div className="footer-column logo-column">
            <div className="footer-logo">
              <Link to="/">
                <img src="/images/site/logobranca.svg" alt="Liv_IAm Logo" />
              </Link>
            </div>
            <p className="footer-tagline">
              Sua assistente astrológica disponível 24/7
            </p>
            <div className="social-links">
              <a href="https://instagram.com/roboliviam" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://facebook.com/roboliviam" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com/roboliviam" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://youtube.com/roboliviam" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-heading">Navegação</h3>
            <ul className="footer-links">
              <li><Link to="/">Início</Link></li>
              <li><Link to="/sobre">Sobre</Link></li>
              <li><Link to="/valores">Valores</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/depoimentos">Depoimentos</Link></li>
              <li><Link to="/contato">Contato</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-heading">Serviços</h3>
            <ul className="footer-links">
              <li><Link to="/mapa-astral">Mapa Astral</Link></li>
              <li><Link to="/sinastria">Sinastria</Link></li>
              <li><Link to="/previsoes">Previsões</Link></li>
              <li><Link to="/orientacao-carreira">Orientação de Carreira</Link></li>
              <li><Link to="/perguntas-especificas">Perguntas Específicas</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-heading">Contato</h3>
            <ul className="contact-info">
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:contato@liviam.com.br">contato@liviam.com.br</a>
              </li>
              <li>
                <i className="fab fa-whatsapp"></i>
                <a href="https://wa.me/5511XXXXXXXXX">WhatsApp</a>
              </li>
              <li>
                <i className="fab fa-instagram"></i>
                <a href="https://instagram.com/roboliviam">@roboliviam</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            &copy; {currentYear} Liv_IAm. Todos os direitos reservados.
          </div>
          
          <div className="legal-links">
            <Link to="/termos-uso">Termos de Uso</Link>
            <Link to="/politica-privacidade">Política de Privacidade</Link>
          </div>
        </div>
        
        <div className="disclaimer">
          <p>
            Este produto está vinculado ao aplicativo ChatGPT, desenvolvido pela OpenAI.
            Para garantir o funcionamento da ferramenta, é necessário acesso contínuo ao
            aplicativo ChatGPT, que pode estar sujeito a alterações de termos de serviço e
            condições estabelecidas pela OpenAI.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;